module.exports = __webpack_public_path__ + "img/faq-icon.f24fbabe.svg";